import { render, staticRenderFns } from "./PBatchRunTaskItem.vue?vue&type=template&id=4de267d8"
import script from "./PBatchRunTaskItem.vue?vue&type=script&lang=js"
export * from "./PBatchRunTaskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/PBatchRun/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FPBatchRun%2FBatchRunTask%2FPBatchRunTaskItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports